import React from 'react';

//components
import WidgetButton from './WidgetButton/WidgetButton';

//enums
import { WidgetType } from  '@/interfaces/widgetPanel';



const ImageWidget = () => {

    function handleImageClick(){
        (window as any).functions?.mediaLibrary?.('Images')
    }

    return (
        <div className="widget-panel-item">
            <WidgetButton type={WidgetType.IMAGE} onClick={handleImageClick} />
        </div>
    )
}
export default ImageWidget